import React from 'react';

const Step2Canvas = ({ state, callbacks }) => {
  // Presets basierend auf aktuellen Bilderkennungsmodellen
  const presets = [
    { name: 'YOLO Standard (640x640)', width: 640, height: 640 },
    { name: 'YOLO Large (1280x1280)', width: 1280, height: 1280 },
    { name: 'EfficientDet (512x512)', width: 512, height: 512 },
    { name: 'EfficientDet (1024x1024)', width: 1024, height: 1024 },
    { name: 'RetinaNet (800x800)', width: 800, height: 800 },
    { name: 'MobileNet (416x416)', width: 416, height: 416 },
    { name: 'SSD (300x300)', width: 300, height: 300 },
  ];

  const applyPreset = (preset) => {
    callbacks.setCanvasSize({ width: preset.width, height: preset.height });
  };

  return (
    <div className="w-full bg-transparent p-0 space-y-4">
      <div>
        <label className="block mb-2 text-xs font-medium text-dark-text-secondary tracking-tight">Modell-Presets</label>
        <div className="grid grid-cols-2 gap-2">
          {presets.map((preset) => (
            <button
              key={preset.name}
              className="py-2.5 px-3 text-xs bg-white border border-dark-border rounded-lg text-dark-text-secondary transition-all duration-150 hover:bg-dark-hover hover:text-dark-text focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-offset-1 font-medium"
              onClick={() => applyPreset(preset)}
            >
              {preset.name}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className="block mb-2 text-xs font-medium text-dark-text-secondary tracking-tight">Benutzerdefinierte Größe</label>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <label className="text-xs text-dark-text-muted tracking-tight font-medium">Breite (px)</label>
            <input
              type="number"
              value={state.canvasSize.width}
              onChange={(e) => callbacks.setCanvasSize({ ...state.canvasSize, width: parseInt(e.target.value) || 640 })}
              min="100"
              max="4000"
              className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs text-dark-text-muted tracking-tight font-medium">Höhe (px)</label>
            <input
              type="number"
              value={state.canvasSize.height}
              onChange={(e) => callbacks.setCanvasSize({ ...state.canvasSize, height: parseInt(e.target.value) || 640 })}
              min="100"
              max="4000"
              className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
            />
          </div>
        </div>
        <p className="text-xs text-dark-text-muted mt-3 leading-relaxed">
          💡 <strong className="text-dark-text-secondary">Hinweis:</strong> Die meisten modernen Bilderkennungsmodelle verwenden quadratische Eingabegrößen. YOLO v5/v7/v8 verwenden standardmäßig 640x640.
        </p>
      </div>

      <div>
        <label className="block mb-2 text-xs font-medium text-dark-text-secondary tracking-tight">Hintergrundfarbe</label>
        <input
          type="color"
          value={state.backgroundColor}
          onChange={(e) => callbacks.setBackgroundColor(e.target.value)}
          className="w-full h-12 cursor-pointer rounded-lg border border-dark-border transition-all duration-150 hover:border-dark-text-muted"
        />
      </div>

      <div>
        <label className="block mb-2 text-xs font-medium text-dark-text-secondary tracking-tight">Annotation-Typ</label>
        <select
          value={state.annotationType}
          onChange={(e) => callbacks.setAnnotationType(e.target.value)}
          className="w-full py-2.5 px-3 bg-white border border-dark-border rounded-lg text-sm text-dark-text transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-dark-text focus:ring-offset-1"
        >
          <option value="boundingBox">Bounding Box (Object Detection)</option>
          <option value="segmentation">Polygon (Instance Segmentation)</option>
        </select>
        <p className="text-xs text-dark-text-muted mt-1.5">
          {state.annotationType === 'boundingBox' 
            ? 'Exportiert rechteckige Bounding Boxes für Object Detection (YOLO Format: class_id center_x center_y width height)'
            : 'Exportiert Polygone für Instance Segmentation (YOLO Format: class_id x1 y1 x2 y2 x3 y3 ...)'}
        </p>
      </div>

    </div>
  );
};

export default Step2Canvas;
